import React, { useState, useEffect } from "react";
import { PDFViewer, Page, Text, View, Document } from "@react-pdf/renderer";
import { Spin } from "antd";
import axios from "axios";
import moment from "moment";
import config from "../../../config";
import PrintHeaderAccount from "../../../Pdf/PrintHeaderAccount";
import PrintFooter from "../../../Pdf/PrintFooter";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import {
  PrintFormateNumber,
  parseReportAmount,
} from "../../../Pdf/PrintFormateNumber";
import { calculateColumnTotal } from "../../Shared/Utility";

const TABLE_WIDTH = 567;

const NOZZLE_COL = {
  sr: 28,
  product: 90,
  no: 40,
  previous: 100,
  current: 100,
  returned: 100,
  used: 109,
};

const SALE_COL = {
  sr: 28,
  inv: 50,
  customer: 140,
  product: 60,
  name: 90,
  qty: 60,
  rate: 60,
  amount: 79,
};

const VOUCHER_COL = {
  sr: 28,
  voucher: 70,
  name: 170,
  desc: 199,
  amount: 100,
};

const fmt = (val, decimals = 0) =>
  PrintFormateNumber(parseReportAmount(val), decimals);

const fmtQty = (val) => PrintFormateNumber(parseReportAmount(val));

const SectionTitle = ({ children }) => (
  <View style={{ marginTop: 6, marginBottom: 2 }}>
    <Text
      style={{
        fontSize: 8,
        fontWeight: "bold",
        fontFamily: "Roboto",
        color: "#000",
      }}
    >
      {children}
    </Text>
  </View>
);

const ThCell = ({ width, label, align }) => (
  <View style={[saleReportStyles.th, { width, textAlign: align || "left" }]}>
    <Text style={saleReportStyles.thValue}>{label}</Text>
  </View>
);

const TdCell = ({ width, value, align }) => (
  <View style={[saleReportStyles.td, { width, textAlign: align || "left" }]}>
    <Text style={saleReportStyles.tdValue}>{value ?? "—"}</Text>
  </View>
);

function PrintDateWiseSummary2() {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");
  const urlParams = new URLSearchParams(window.location.search);
  const Dated = urlParams.get("Dated");

  const [data, setData] = useState({});
  const [nozzelData, setNozzelData] = useState([]);
  const [listOfSales, setListOfSales] = useState([]);
  const [PaymentsGiven, setPaymentsGiven] = useState([]);
  const [CashReceived, setCashReceived] = useState([]);
  const [Expense, setExpense] = useState([]);
  const [listOfCreditSaleVouchers, setListOfCreditSaleVouchers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Print DateWise Summary 2";
    if (!Dated || !UserID || !AccessKey) {
      setLoading(false);
      return;
    }

    setLoading(true);
    axios({
      method: "post",
      url: config.base_url + "Report/GetDailySummaryReport2",
      headers: { "Content-Type": "application/json" },
      data: {
        UserID,
        AccessKey,
        Dated: moment(Dated).isValid()
          ? moment(Dated).format("YYYY-MM-DD")
          : Dated,
      },
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setData(response.data);
          setNozzelData(response.data.listofReading || []);
          setListOfSales(response.data.ListofProducts || []);
          setPaymentsGiven(response.data.listofCashGiven || []);
          setExpense(response.data.listofExpenses || []);
          setCashReceived(response.data.listofCashreceipt || []);
          setListOfCreditSaleVouchers(
            response.data.listofCreditSaleVouchers || []
          );
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, [Dated, UserID, AccessKey]);

  const datedLabel =
    Dated && moment(Dated).isValid()
      ? moment(Dated).format(config.date_format)
      : "—";

  const salesTotal =
    data.SalesTotal !== undefined && data.SalesTotal !== null
      ? parseReportAmount(data.SalesTotal)
      : calculateColumnTotal(listOfSales, "Amount");

  const creditVoucherTotal =
    data.creditSalesWithVoucher !== undefined &&
    data.creditSalesWithVoucher !== null
      ? parseReportAmount(data.creditSalesWithVoucher)
      : calculateColumnTotal(listOfCreditSaleVouchers, "Amount");

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page} wrap>
        <PrintHeaderAccount compact />
        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Summary Sheet 2</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Date: {datedLabel}
            </Text>
          </View>

          <SectionTitle>Nozzle Details</SectionTitle>
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={NOZZLE_COL.sr} label="Sr.#" />
              <ThCell width={NOZZLE_COL.product} label="Product" />
              <ThCell width={NOZZLE_COL.no} label="No." />
              <ThCell width={NOZZLE_COL.previous} label="Previous" align="right" />
              <ThCell width={NOZZLE_COL.current} label="Current" align="right" />
              <ThCell width={NOZZLE_COL.returned} label="Returned" align="right" />
              <ThCell width={NOZZLE_COL.used} label="Used" align="right" />
            </View>
            {nozzelData.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={NOZZLE_COL.sr} value={String(index + 1)} />
                <TdCell width={NOZZLE_COL.product} value={item.ProductCode} />
                <TdCell width={NOZZLE_COL.no} value={item.Pump_No} />
                <TdCell
                  width={NOZZLE_COL.previous}
                  value={fmtQty(item.Last_Reading)}
                  align="right"
                />
                <TdCell
                  width={NOZZLE_COL.current}
                  value={fmtQty(item.Current_Reading)}
                  align="right"
                />
                <TdCell
                  width={NOZZLE_COL.returned}
                  value={fmtQty(item.Returned)}
                  align="right"
                />
                <TdCell
                  width={NOZZLE_COL.used}
                  value={fmtQty(item.UsedQuantity)}
                  align="right"
                />
              </View>
            ))}
          </View>

          <SectionTitle>Sale Details</SectionTitle>
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={SALE_COL.sr} label="Sr.#" />
              <ThCell width={SALE_COL.inv} label="Inv.#" />
              <ThCell width={SALE_COL.customer} label="Customer" />
              <ThCell width={SALE_COL.product} label="Product" />
              <ThCell width={SALE_COL.name} label="Name" />
              <ThCell width={SALE_COL.qty} label="Qty" align="right" />
              <ThCell width={SALE_COL.rate} label="Rate" align="right" />
              <ThCell width={SALE_COL.amount} label="Amount" align="right" />
            </View>
            {listOfSales.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={SALE_COL.sr} value={String(index + 1)} />
                <TdCell
                  width={SALE_COL.inv}
                  value={item.Invoice_ID || item.Receipt_No || "—"}
                />
                <TdCell
                  width={SALE_COL.customer}
                  value={item.Account_BE?.Name || "—"}
                />
                <TdCell
                  width={SALE_COL.product}
                  value={item.Product_BE?.ProductCode || "—"}
                />
                <TdCell
                  width={SALE_COL.name}
                  value={item.Product_BE?.Name || "—"}
                />
                <TdCell
                  width={SALE_COL.qty}
                  value={fmtQty(item.Quantity)}
                  align="right"
                />
                <TdCell
                  width={SALE_COL.rate}
                  value={fmtQty(item.Price)}
                  align="right"
                />
                <TdCell
                  width={SALE_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.td,
                  {
                    width:
                      SALE_COL.sr +
                      SALE_COL.inv +
                      SALE_COL.customer +
                      SALE_COL.product +
                      SALE_COL.name +
                      SALE_COL.qty +
                      SALE_COL.rate,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.tdValue}>Total</Text>
              </View>
              <TdCell width={SALE_COL.amount} value={fmt(salesTotal)} align="right" />
            </View>
          </View>

          <SectionTitle>Credit Voucher Sales</SectionTitle>
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.name} label="Customer Name" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {listOfCreditSaleVouchers.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.name}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell width={VOUCHER_COL.desc} value={item.Description || "—"} />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.td,
                  {
                    width:
                      VOUCHER_COL.sr +
                      VOUCHER_COL.voucher +
                      VOUCHER_COL.name +
                      VOUCHER_COL.desc,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.tdValue}>Total</Text>
              </View>
              <TdCell
                width={VOUCHER_COL.amount}
                value={fmt(creditVoucherTotal)}
                align="right"
              />
            </View>
          </View>

          <SectionTitle>Payment Receipts</SectionTitle>
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.name} label="Customer Name" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {CashReceived.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.name}
                  value={item.Credit_Account?.Name || "—"}
                />
                <TdCell width={VOUCHER_COL.desc} value={item.Description || "—"} />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.td,
                  {
                    width:
                      VOUCHER_COL.sr +
                      VOUCHER_COL.voucher +
                      VOUCHER_COL.name +
                      VOUCHER_COL.desc,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.tdValue}>Total</Text>
              </View>
              <TdCell
                width={VOUCHER_COL.amount}
                value={fmt(data.cashReceivedTotal)}
                align="right"
              />
            </View>
          </View>

          <SectionTitle>Payment Given</SectionTitle>
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.name} label="Account Name" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {PaymentsGiven.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.name}
                  value={
                    item.Debit_Account?.Name || item.Credit_Account?.Name || "—"
                  }
                />
                <TdCell width={VOUCHER_COL.desc} value={item.Description || "—"} />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.td,
                  {
                    width:
                      VOUCHER_COL.sr +
                      VOUCHER_COL.voucher +
                      VOUCHER_COL.name +
                      VOUCHER_COL.desc,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.tdValue}>Total</Text>
              </View>
              <TdCell
                width={VOUCHER_COL.amount}
                value={fmt(data.cashGiven)}
                align="right"
              />
            </View>
          </View>

          <SectionTitle>Expense Details</SectionTitle>
          <View style={[saleReportStyles.table, { width: TABLE_WIDTH }]}>
            <View style={saleReportStyles.tableHead}>
              <ThCell width={VOUCHER_COL.sr} label="Sr.#" />
              <ThCell width={VOUCHER_COL.voucher} label="Voucher No" />
              <ThCell width={VOUCHER_COL.name} label="Expense Account" />
              <ThCell width={VOUCHER_COL.desc} label="Description" />
              <ThCell width={VOUCHER_COL.amount} label="Amount" align="right" />
            </View>
            {Expense.map((item, index) => (
              <View key={index} style={saleReportStyles.row}>
                <TdCell width={VOUCHER_COL.sr} value={String(index + 1)} />
                <TdCell width={VOUCHER_COL.voucher} value={item.VoucherNo} />
                <TdCell
                  width={VOUCHER_COL.name}
                  value={item.Debit_Account?.Name || "—"}
                />
                <TdCell width={VOUCHER_COL.desc} value={item.Description || "—"} />
                <TdCell
                  width={VOUCHER_COL.amount}
                  value={fmt(item.Amount)}
                  align="right"
                />
              </View>
            ))}
            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.td,
                  {
                    width:
                      VOUCHER_COL.sr +
                      VOUCHER_COL.voucher +
                      VOUCHER_COL.name +
                      VOUCHER_COL.desc,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.tdValue}>Total</Text>
              </View>
              <TdCell
                width={VOUCHER_COL.amount}
                value={fmt(data.expensesPaid)}
                align="right"
              />
            </View>
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="SummarySheet2.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintDateWiseSummary2;
